<template>
    <iframe :src="url" scrolling="auto"></iframe>
</template>
<script>
import { changeTitleClick } from '@/utils/utils'
export default {
  name: 'webPage',
  components: {
  },
  data () {
    return {
      url: '', // 外链地址
      title: ''
    }
  },
  async created () {
  },
  mounted () {
    this.getA()
    changeTitleClick(this.title)
  },
  methods: {
    // 获取url参数
    getA () {
      const geturl = window.location.href
      const seturl = geturl.split('#')[0]
      const getqyinfo = seturl.split('?')[1]
      const getqys = getqyinfo.split('&')
      const obj = {} // 创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split('=')
        const key = item[0]
        const value = item[1]
        obj[key] = value
      }
      this.url = decodeURIComponent(obj.url)
      this.title = decodeURIComponent(obj.title)
    }
  }
}
</script>
<style lang="scss" scoped>
iframe {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border: none;
}
</style>
